import React, { FC } from 'react';
import { Card, FlexRow, INavigationItemProps, NavigationItem } from '../../../../../ui-toolkit';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

interface IEscrowSubNavigationProps {
  orderId: string;
}

const spaAdminOrderEscrowOptions = (orderId: string): INavigationItemProps[] => [
  {
    text: 'Disbursed Transactions',
    to: `/spa/admin/order/${orderId}/escrow`,
  },
  {
    text: 'Create/Edit Transactions',
    to: `/spa/admin/order/${orderId}/escrow/edit`,
  },
];

export const SpaEscrowSubNavigation: FC<IEscrowSubNavigationProps> = ({ orderId }) => {
  const location = useLocation();
  const currentPathname = location.pathname;
  return (
    <StyledCard>
      <FlexRow>
        {spaAdminOrderEscrowOptions(orderId).map((nav) => (
          <NavigationItem
            {...nav}
            key={nav.text}
            isActive={currentPathname === nav.to}
            showUnderline={currentPathname === nav.to}
          />
        ))}
      </FlexRow>
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  padding-left: ${(props) => props.theme.spacing.spacing2};
`;
